import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { DownloadIglooLogs } from '@/components/business/igloo-logs'

import Filter from '../../Filter/Filter'
import { getRoles } from './helpers'
import { ManagementUsersToolbarProps, RoleOption } from './types'

const ManagementUsersToolbar = ({
  selectedBuilding,
  setFilterManagementUsersList,
}: ManagementUsersToolbarProps) => {
  const { t } = useTranslation(['management-users'])
  const roles = getRoles(t)
  const [selectedRole, setSelectedRole] = useState<RoleOption[] | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (selectedRole) setFilterManagementUsersList(selectedRole)
  }, [selectedRole, setFilterManagementUsersList])

  const onClickAddNew = () => {
    if (!selectedBuilding) return
    navigate(`/dashboard/building-dashboard/management-users/${selectedBuilding.id}/new`)
  }

  return (
    <div className="management-users-toolbar">
      <div className="management-users-toolbar__wrapper">
        <span className="management-users-toolbar__search">
          {t('management-users:toolbar.filterByRoleLabel')}
        </span>

        <Filter
          additionalClass="ctp-management-users-navbar__filter"
          config={{ displayValuesList: false, hasSearch: false, multiple: true }}
          name="Role"
          options={roles}
          placeholder={
            selectedRole && selectedRole.length
              ? selectedRole.map((role) => role.text).join(', ')
              : t('management-users:form.roleSelectPlaceholder')
          }
          value={selectedRole || []}
          variant="rounded"
          onChange={(e) => {
            const v = e.target.value
            setSelectedRole(Array.isArray(v) ? v : [v])
          }}
        />

        <button
          className="button button-primary absolute-add-button"
          disabled={!selectedBuilding}
          style={{ marginLeft: 20 }}
          onClick={onClickAddNew}
        >
          {t('management-users:toolbar.addNewButton')}
        </button>

        <DownloadIglooLogs />
      </div>
    </div>
  )
}

export default ManagementUsersToolbar
